import { createSelector } from 'reselect';
import { RootState } from 'shared/stores';

export const rpAlertStateSelector = (state: RootState) => state.rp4.alert

export const alertSelector = createSelector(rpAlertStateSelector, state => state.alertToDisplay)
